export default __webpack_public_path__ + "static/fourseasons-0974dd8919ef55352756ff3b6e555216.jpg";